module.exports = __webpack_public_path__ + "static/avatar-12f5ad8f4133b69c8f4dec1fb20cbbf3.jpg";